<template>
  <div class="wrapper col-xs-3 col-md-3 m-b-15">
    <div class="widget-15 panel no-border bg-success no-margin widget-loader-bar">
      <h3 class="no-margin p-b-5 text-white">{{this.qty}}</h3>
      <span class="fs-13 text-white">Clients ce mois-ci</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .wrapper {
    height: 165px;
    padding: 0;
    >div {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      justify-content: center;
      padding-left: 35%;
      @media screen and (max-width: 991px) {
        height: 100% !important;
      }
    }
    h3 {
      font-size: 42px;
    }
    span {
      max-width: 90%;
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .bg-success {
    background:#eb7593;
  }
</style>

<script type="text/babel">
  import {mapState, mapActions} from 'vuex'
  export default {

    name: "NewCustomers",

    props:["qty"]

  }
</script>



// WEBPACK FOOTER //
// client/components/Dashboard/Stats/NewCustomers.vue